var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBusElectric = function SvgBusElectric(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fffb00",
    d: "M7 0c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7 3.13-7 7-7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgba(0,0,0,0.8)",
    d: "m9.61 6.74-2.44 4.58c-.26.48-.99.26-.94-.28l.23-2.49c.03-.29-.2-.55-.5-.55H4.84a.5.5 0 0 1-.44-.74l2.44-4.58c.26-.48.99-.26.94.28l-.23 2.49c-.03.29.2.55.5.55h1.12c.38 0 .62.4.44.74"
  })));
};
export default SvgBusElectric;